<template>
  <div class="bg">
    <div class="content">
      <img
        class="success"
        src="@/assets/images/success.png"
        alt="成功"
      />
      <p>{{title}}...</p>
      <p>
        {{content}}
      </p>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import ServerBank from '@/components/ServerBank.vue';
import { mapState } from 'vuex';
export default {
  name: 'DrawingMoneyReview',
  components: {
    ServerBank,
  },
  data() {
    const { orderId, productId } = this.$route.query;
    return {
      num: 0,
      title: '支用审批中',
      content: '您的支用申请已提交成功。审核结果将在24小时内反馈，感谢您的耐心等待。',
    };
  },
  mounted() {
    document.title = this.title;
    this.jumpCurrPage();
  },
  methods: {
    // 后端进行跳转
    jumpCurrPage() {
      const oldNum = this.num;
      const { orderId } = this.commonForms;
      if (oldNum < 6) {
        this.num = oldNum + 1;
        this.$api.PublicPage.jumpCurrPage({
          orderId: orderId || localStorage.getItem('orderId'),
        })
          .then((res) => {
            if (res.success) {
              if (res.data) {
                window.location.href = res.data;
              } else {
                setTimeout(
                  () => this.jumpCurrPage(), 5000,
                );
              }
            } else {
              setTimeout(
                () => this.jumpCurrPage(), 5000,
              );
            }
          });
      }
    },
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
  },

};
</script>
<style scoped>
/* 提款审批中 */
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 60px;
  color: #a6a6a6;
  box-sizing: border-box;
}

.content .success {
  width: 60px;
  height: 60px;
}

.content p:nth-child(2) {
  font-size: 16px;
  font-weight: bold;
  margin: 30px 0;
}

.content p:nth-child(3) {
  font-size: 14px;
  text-align: left;
}
.bg {
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>
